import React, { useEffect } from "react";
import ProfileForm from "./ProfileForm.js";
import ProfileConfig from "./ProfileConfig";
import ProfileAbo from "./ProfileAbo";
import { fetchWithAuth } from '../services/AuthService';

const ProfileContent = ({
  activeSection,
  profileData,
  handleChange,
  handleSubmit,
  errors,
  setErrors,
  i18n,
  t,
  handleLogout,
}) => {

  const logLogout = async () => {
    try {
      const response = await fetchWithAuth('/api/auth/logout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: "",
      });
  
      if (!response.ok) {
        throw new Error('Erreur lors du logout');
      }
  
      await response.json();
  
    } catch (error) {
      console.error('Erreur lors du logout :', error);
    } finally {
    }
  };

   useEffect(() => {
    if (activeSection === "logout") {
      logLogout();
      handleLogout();
    }
  }, [activeSection, handleLogout]);

  switch (activeSection) {
    case "profile":
      return (
        <ProfileForm
          profileData={profileData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          errors={errors}
          setErrors={setErrors}
        />
      );
    case "abo":
      return <ProfileAbo />;
    case "config":
      return <ProfileConfig i18n={i18n} t={t}/>;
    case "logout":
      return null; // le logout sera fait dans useEffect
    default:
      return null;
  }
};

export default ProfileContent;
